import { ActionTypes as types } from '../../constants';
import { Dispatch } from 'redux';
import { StatusType } from '../../components/TwoFactorAuthentication/MultiFactorAuthentication';

export default (mfaEnabled: StatusType) => (dispatch: Dispatch) => {
  const isEnabled = mfaEnabled === 'enable';

  dispatch({
    type: types.MFA_ENABLED,
    payload: isEnabled,
  });
};
